module.exports = __webpack_public_path__ + "img/evaluating_img7.53478ea0.jpg";